// extracted by mini-css-extract-plugin
export default {"root":"a9GXSG1s0lKpBPxCkI3x"};